import { render, staticRenderFns } from "./out_warehouse_add.vue?vue&type=template&id=2ef4e352&scoped=true&"
import script from "./out_warehouse_add.vue?vue&type=script&lang=js&"
export * from "./out_warehouse_add.vue?vue&type=script&lang=js&"
import style0 from "./out_warehouse_add.vue?vue&type=style&index=0&id=2ef4e352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4e352",
  null
  
)

export default component.exports